import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class MyOrganisationService extends RestfulService<Models.MyOrganisation> {

  constructor(private restService: RestService) {
    super(Models.MyOrganisation);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('my-organisations');
  }
}
